import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["all", "box"]

  toggleAll(event) {
    const checked = this.allTarget.checked

    this.boxTargets.forEach((checkbox) => {
      checkbox.checked = checked
    })
  }

  toggleIndividual(event) {
    const allChecked = this.boxTargets.every((checkbox) => checkbox.checked)
    this.allTarget.checked = allChecked
  }
}

